<template>

  <default-view>

    <template #header>
      <span>Ampli Var Stat</span>
    </template>

    <template #toolbar-items>
      <v-spacer></v-spacer>

      <v-toolbar-items>
        <!-- add new plate -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on"
                   style="padding-right: 12px;"
                   @click="btnAnalysisNew_click">
              <v-badge
                color="green lighten-3 "
                light avatar bottom overlap>
                <template #default>
                  <v-icon>mdi-clipboard-list-outline</v-icon>
                </template>
                <template #badge>
                  <v-icon size="20" style="margin-top: -2px;">
                    mdi-plus
                  </v-icon>
                </template>
              </v-badge>
            </v-btn>
          </template>

          <template #default>
            <span>New analysis ...</span>
          </template>
        </v-tooltip>
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items>

        <v-tooltip>
          <template #activator="{ on }">
            <v-btn icon v-on="on" @click="btnRefresh_click">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <template #default>
            Refresh analysis list
          </template>
        </v-tooltip>
      </v-toolbar-items>

    </template>

    <template #content>

      <v-data-table
        :items="analysis_items"
        item-key="id"
        :headers="analysis_headers"
        hide-default-footer
        disable-pagination
      >
        <template #item.name="{ item }">

          <!-- Notes -->
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="btnAnalysisEdit_click(item.id)">
                <v-icon v-if="item.notes">mdi-message-text-outline</v-icon>
                <v-icon v-else="">mdi-message-outline</v-icon>
              </v-btn>
            </template>
            <template #default>
              <span style="max-width: 45%;">
                {{ item.notes }}
              </span>
            </template>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <span v-on="on" style="cursor: default;">{{ item.name }}</span>
            </template>

            <template #default>
              <pre v-if="user.is_superuser">{{ JSON.stringify(item, null, 2) }}</pre>
            </template>
          </v-tooltip>

        </template>

        <template #item.state_dt="{ item }">
          <div>
            {{ item.state_dt | moment("YYYY MMM DD HH:mm:ss") }}
            <div class="text--lighten-1" style="font-size: 0.8em;">
              {{ item.state_dt | moment('from', 'now') }}
            </div>
          </div>
        </template>

        <template #item.actions="{ item }">
          <!-- Props analysis edit -->
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="btnAnalysisEdit_click(item.id)">
                <v-icon>mdi-file-document-edit-outline</v-icon>
              </v-btn>
            </template>
            <template #default>
              Edit analysis props ...
            </template>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="btnAnalysisRun_click(item.id)">
                <v-icon>mdi-run-fast</v-icon>
              </v-btn>
            </template>
            <template #default>
              Run analysis
            </template>
          </v-tooltip>

        </template>

      </v-data-table>

      <analysis-props-dialog
        ref="dlgAnalysisProps"
        v-model="shown_dlgAnalysisProps"
        :analysis="analysis_obj"
        @accepted="dlgAnalysisProps_accepted"
        @closing="dlgAnalysisProps_closing"
      >
      </analysis-props-dialog>

    </template>

  </default-view>
</template>

<script>

	import {moment} from 'moment'
	import {mapActions, mapGetters} from 'vuex'
	import {
		VDataTable, VSpacer, VToolbarItems, VTooltip, VBtn, VIcon, VBadge,
	} from 'vuetify'

	import AnalysisPropsDialog from './AnalysisPropsDialog'

	export default {
		name: 'ampli-var-stat-list',

		components: {
			VDataTable, VSpacer, VToolbarItems, VTooltip, VBtn, VIcon, VBadge,
			AnalysisPropsDialog,
		},

		data: function () {
			return {
				analysis_headers: [
					{text: 'Name', align: 'start', value: 'name',},
					{text: 'Project', align: 'start', value: 'project.name',},
					{text: 'Panel', align: 'start', value: 'panel.short',},
					{text: 'State', align: 'center', value: 'state',},
					{text: 'State date', align: 'start', value: 'state_dt',},
					{text: 'Actions', align: 'start', value: 'actions', width: '104px', sortable: false},
				],

				shown_dlgAnalysisProps: false,
				analysis_obj: null, // если в диалоге null, значит новый создаем
			}
		},

		computed: {
			...mapGetters({
				analysis_list: 'ampli_var_stat/analysis_list',
				analyzes: 'ampli_var_stat/analyzes',

				user: 'auth/user',
			}),

			analysis_items: function () {
				return this.analysis_list
			}
		},

		mounted() {
			this.data_load()
		},

		methods: {
			...mapActions({
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
				message_add: 'message/add',

				fetch_project_list: 'projects/project_list',
				fetch_panel_list: 'panels/update',
				fetch_analysis_list: 'ampli_var_stat/analysis_list',

				store_analysis_create: 'ampli_var_stat/analysis_create',
				store_analysis_update: 'ampli_var_stat/analysis_update',
				store_analysis_run: 'ampli_var_stat/analysis_run',
			}),

			project_name: function (project_id) {
				this.analyzes
			},

			panel_name: function (panel_id) {

			},

			data_load: function () {
				this.progress_begin({message: "Loading analyzes ..."})

				Promise.all([
					this.fetch_project_list(),
					this.fetch_panel_list(),
				])
					.then(() => {
						return this.fetch_analysis_list()
							.then((vals) => {
								const k = 7
							})
					})
					.catch((error) => {
						this.message_add(error)
					})
					.finally(() => {
						this.progress_end()
					})
			},

			analysis_create: function (analysis) {
				this.progress_begin({message: "Create analysis..."})
				// если не вернем Promise, то результат потеряем навсегда
				return this.store_analysis_create({analysis, details: false})
					.then(() => {
						this.message_add({type: 'success', html: "Analysis created."})
						return true;
					})
					.catch((error) => {
						this.message_add(error)
						return false // false - диалог не закроется
					})
					.finally(() => {
						this.progress_end()
					})
			},

			analysis_update: function (analysis) {
				this.progress_begin({message: "Update analysis..."})
				// если не вернем Promise, то результат потеряем навсегда
				return this.store_analysis_update({analysis, details: false})
					.then(() => {
						this.message_add({type: 'success', html: "Analysis updated."});
						return true;
					})
					.catch((error) => {
						this.message_add(error);
						return false
					})
					.finally(() => {
						this.progress_end()
					})
			},

			// -- Handle controls' events --

			btnRefresh_click: function (e) {
				this.data_load()
			},

			btnAnalysisNew_click: function (e) {
				this.analysis_obj = null
				this.shown_dlgAnalysisProps = true
			},

			btnAnalysisEdit_click: function (analysis_id) {
				const k = 7

				this.analysis_obj = this.analyzes[analysis_id]
				this.shown_dlgAnalysisProps = true
			},

			dlgAnalysisProps_accepted: function (event) {
				// TODO: проследить откуда берется объект со значениями полей
				const analysis = {}
				for (let key in event.inputs) {
					if (key !== 'id' || this.analysis_obj !== null)
						analysis[key] = event.inputs[key]
				}

				// analysis_obj - что передавали в диалог,
				// если null - значит новый создаем
				if (this.analysis_obj == null) {
					event.result(this.analysis_create(analysis))
				} else {
					event.result(this.analysis_update(analysis))
				}
			},

			dlgAnalysisProps_closing: function (res) {
				this.shown_dlgAnalysisProps = false
				this.analysis_obj = null
			},

			btnAnalysisRun_click: function (analysis_id) {
				this.progress_begin({message: 'Running analysis ...'})
				this.store_analysis_run({analysis_id})
					.then(() => {
						const k = 7
					})
					.catch((error) => {
						this.message_add(error)
					})
					.finally(() => {
						this.progress_end()
					})
			},
		},

	}
</script>

<style scoped>

</style>